import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/utils';

interface UserAvatarProps {
  email?: string;
  imageUrl?: string;
  className?: string;
}

export const UserAvatar = ({ email, imageUrl, className }: UserAvatarProps) => {
  const fallbackLetter = email ? email.charAt(0).toUpperCase() : '?';

  return (
    <Avatar className={cn('h-8 w-8', className)}>
      <AvatarImage src={imageUrl} alt={`${email} avatar`} />
      <AvatarFallback className="bg-primary text-primary-foreground text-sm font-medium">
        {fallbackLetter}
      </AvatarFallback>
    </Avatar>
  );
};
